import { getUserAgent } from './isomorphic-useragent';
import type { MobileDevices } from '@seek/chalice-types';
import { isGooglebotMobile } from './googlebot';

const isMobile = (ua: string) =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);

// Mobile device detection
export const isMobileUserAgent = (): boolean => {
  const userAgent = getUserAgent();
  if (isGooglebotMobile(userAgent)) {
    return true;
  }

  return isMobile(userAgent);
};

export const currentDevice = (): MobileDevices => {
  const ua = getUserAgent() || '';

  if (ua.match(/iphone/i)) {
    return 'iOS';
  }

  if (ua.match(/Android/i)) {
    return 'Android';
  }

  return 'Other';
};
